// extracted by mini-css-extract-plugin
export default {"heading":"RecipeForm_heading__5dXkx","full-width":"RecipeForm_full-width__6C+nZ","grid1":"RecipeForm_grid1__g6sFN","grid":"RecipeForm_grid__WC-A9"};